import { useState } from "react";

import classes from "./Hero.module.css";
import { siteName } from "../../util/config";

export default function Hero({ fetchData }) {
  const [trackingId, setTrackingId] = useState("");

  return (
    <div className={classes.hero}>
      <h1>Track Your Skyheight Orders with Ease</h1>
      <h3>Fast, Reliable, and Real-Time Tracking for {siteName}'s Products</h3>
      <p>
        Stay updated on your shipments from Skyheight China to anywhere in the
        world. Enter your tracking number and get real-time updates on your
        order's journey only for {siteName} products, delivered globally with
        precision.
      </p>
      <div className={classes.action}>
        <input
          type="text"
          placeholder="tracking number"
          value={trackingId}
          onChange={(e) => setTrackingId(e.target.value)}
        />
        <button onClick={() => fetchData(trackingId)}>Track Order</button>
      </div>
    </div>
  );
}
